<template>
  <div class="camp">
    <div class="top-content">
      <div class="wdd">
        <p class="top-tip">2020夏季国外营地项目报名通道已开启！！</p>
        <Row class="carousel">
          <i-col span="17"
                 style="width: 580px">
            <Carousel loop
                      :autoplay="false"
                      :autoplay-speed="5000">
              <Carousel-item class="demo-carousel">
                <img src="@/assets/insidecamp/c1.png"
                     alt="" />
              </Carousel-item>
              <Carousel-item class="demo-carousel">
                <img src="@/assets/insidecamp/c2.jpg"
                     alt="" />
              </Carousel-item>
              <Carousel-item class="demo-carousel">
                <img src="@/assets/insidecamp/c3.jpg"
                     alt="" />
              </Carousel-item>
              <Carousel-item class="demo-carousel">
                <img src="@/assets/insidecamp/c4.jpg"
                     alt="" />
              </Carousel-item>
            </Carousel>
          </i-col>
          <i-col span="7"
                 style="width: 275px">
            <Carousel loop
                autoplay
                :autoplay-speed="5000" dots="none" arrow="never">
              <Carousel-item class="camp-word">
                <h1>Green Camp营</h1>
                <p>在Green Camp营，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</p>
                <p>时间：5天4夜
                  <br />地点：巴厘岛
                  <br /> 开营时间：07.22-07.27</p>
                <router-link to="/camp-detail">查看详情</router-link>
              </Carousel-item>
              <Carousel-item class="camp-word">
                <h1>Green Camp营</h1>
                <p>在Green Camp营，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</p>
                <p>时间：5天4夜
                  <br />地点：巴厘岛
                  <br /> 开营时间：07.22-07.27</p>
                <router-link to="/camp-detail">查看详情</router-link>
              </Carousel-item>
              <Carousel-item class="camp-word">
                <h1>Green Camp营</h1>
                <p>在Green Camp营，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</p>
                <p>时间：5天4夜
                  <br />地点：巴厘岛
                  <br /> 开营时间：07.22-07.27</p>
                <router-link to="/camp-detail">查看详情</router-link>
              </Carousel-item>
              <Carousel-item class="camp-word">
                <h1>Green Camp营</h1>
                <p>在Green Camp营，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</p>
                <p>时间：5天4夜
                  <br />地点：巴厘岛
                  <br /> 开营时间：07.22-07.27</p>
                <router-link to="/camp-detail">查看详情</router-link>
              </Carousel-item>
            </Carousel>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="explain">
      <svg-icon class="wave"
                icon-class="camp1"></svg-icon>
    </div>
    <div class="content">
      <div class="wd">
        <div class="logo">
          <img src="@/assets/insideCamp/l1.png"
               alt="" />
        </div>
        <p class="item-title">少儿编程国外营地项目特色</p>
        <Row class="tip">
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/insideCamp/c2.png"
                   alt="" />
            </div>
            <p>全球前沿STEAM</p>
            <p>教育活动课程</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/insideCamp/c3.png"
                   alt="" />
            </div>
            <p>全身心融入原生态</p>
            <p>自然营地中</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/insideCamp/c4.png"
                   alt="" />
            </div>
            <p>融合中国传统文化</p>
            <p>和人文自然</p>
          </i-col>
          <i-col span="6">
            <div class="circle">
              <img src="@/assets/insideCamp/c5.png"
                   alt=""
                   style="margin-top: 15px;" />
            </div>
            <p>团队分工合作</p>
            <p>项目制完成任务</p>
          </i-col>
        </Row>
        <div class="logo">
          <img src="@/assets/insideCamp/l1.png"
               alt="" />
        </div>
        <div>
          <p class="item-title">2021年上半年国外营地项目</p>
          <p class="small-title">
            2021年开启全新优质国外营地项目，包括编程、3D打印、机器人拼装等STEAM创客课程营地选址包括美国、以色列、新加坡等地，让营员全身心融入原生态自然营地中
          </p>
          <Row type="flex"
               align="middle"
               class="select-btns">
            <i-col span="3">
              <Button :class="'btn ' + (type === 'preWeek' ? 'active' : '')"
                      size="large"
                      shape="circle"
                      @click="getWorkRank('preWeek')">全部日期</Button>
            </i-col>
            <i-col span="3">
              <Button size="large"
                      shape="circle"
                      :class="'btn ' + (type === 'star' ? 'active' : '')"
                      @click="getWorkRank('star')">最近1个月</Button>
            </i-col>
            <i-col span="3">
              <Button size="large"
                      shape="circle"
                      :class="'btn ' + (type === 'score' ? 'active' : '')"
                      @click="getWorkRank('score')">最近3个月</Button>
            </i-col>
            <i-col span="3">
              <Button size="large"
                      shape="circle"
                      :class="'btn ' + (type === 'score' ? 'active' : '')"
                      @click="getWorkRank('score')">最近半年</Button>
            </i-col>
          </Row>
        </div>

        <div class="course-list">
          <Row type="flex"
               align="middle">
            <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u1.jpg" alt="">
              <div class="introduce" v-if="showIndex == 1" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 1">
                <h1>智造发明家营 <br /> 2020.7.22～27</h1>
                <p>清远英德 <br /> 5日4夜</p>
              </div>
            </i-col>
             <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u2.jpg" alt="">
              <div class="introduce" v-if="showIndex == 2" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 2">
                <h1>全英创造营 <br /> 2020.7.22～27</h1>
                <p>新加坡 <br /> 5日4夜</p>
              </div>
            </i-col>
             <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u3.jpg" alt="">
              <div class="introduce" v-if="showIndex == 3" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 3">
                <h1>智造发明家营 <br /> 2020.7.22～27</h1>
                <p>巴厘岛 <br /> 5日4夜</p>
              </div>
            </i-col>
             <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u4.jpg" alt="">
              <div class="introduce" v-if="showIndex == 4" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 4">
                <h1>智造发明家营 <br /> 2020.7.22～27</h1>
                <p>清远英德 <br /> 5日4夜</p>
              </div>
            </i-col>
             <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u5.jpg" alt="">
              <div class="introduce" v-if="showIndex == 5" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 5">
                <h1>智造发明家营 <br /> 2020.7.22～27</h1>
                <p>新加坡 <br /> 5日4夜</p>
              </div>
            </i-col>
             <i-col span="8"
                   class="item-course">
              <img src="@/assets/insideCamp/u5.jpg" alt="">
              <div class="introduce" v-if="showIndex == 6" @mouseleave="showIndex = ''">
                <div class="h">剩余报名名额 <span>8</span> 人</div>
                <Button type="primary" shape="circle" class="btn">了解详情</Button>
              </div>
              <div class="introduce" v-else @mouseover="showIndex = 6">
                <h1>智造发明家营 <br /> 2020.7.22～27</h1>
                <p>巴厘岛 <br /> 5日4夜</p>
              </div>
            </i-col>
          </Row>
        </div>

        <Button class="more-camp">更多营地安排</Button>
        <Row class="more" type="flex" justify="center" align="middle">
          <i-col>
            <img class="b" src="@/assets/insideCamp/b1.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>智造发明家营</h3>
            <h6>在智造发明家营，我们将带领营员前往拥有原始生态环境的清远市，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 清远田野绿世界<br/>
              营期 &nbsp; 5天4夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a to="/camp-detail" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col>
            <img class="b" src="@/assets/insideCamp/b2.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>智造发明家营</h3>
            <h6>在智造发明家营，我们将带领营员前往拥有原始生态环境的清远市，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 清远田野绿世界<br/>
              营期 &nbsp; 5天4夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col>
            <img class="b" src="@/assets/insideCamp/b3.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>全英创客营</h3>
            <h6>在全英创客营，我们将带领营员前往拥有原始生态环境的新加坡，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 新加坡<br/>
              营期 &nbsp; 8天7夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col>
            <img class="b" src="@/assets/insideCamp/b4.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>全英创客营</h3>
            <h6>在全英创客营，我们将带领营员前往拥有原始生态环境的新加坡，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 新加坡<br/>
              营期 &nbsp; 8天7夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col>
            <img class="b" src="@/assets/insideCamp/b5.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>Green Camp</h3>
            <h6>在Green Camp，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 巴厘岛<br/>
              营期 &nbsp; 10天9夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col>
            <img class="b" src="@/assets/insideCamp/b5.jpg" alt="">
          </i-col>
          <i-col span="12" class="more-explain">
            <h3>Green Camp</h3>
            <h6>在Green Camp，我们将带领营员前往拥有原始生态环境的巴厘岛，共同感受创客科技与户外生态自然的有机融合。</h6>
            <p>
              年龄 &nbsp; 6-12岁 <br />
              价格 &nbsp; 5000元/人<br/>
              营地 &nbsp; 巴厘岛<br/>
              营期 &nbsp; 10天9夜<br/>
              主题 &nbsp; 编程 机器人 竞赛
            </p>
            <router-link to="/camp-detail">营地详情</router-link >
            <a href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
        </Row>
        <p class="item-title">为什么选择少儿编程</p>
        <p class="small-title">教育第一，技术第二</p>
        <Row class="tip">
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci1"></svg-icon>
            </div>
            <p>充满激情的导师</p>
            <p class="small-tip">导师团队由毕业于国内外顶尖大学高校热衷营地教育与STEAM创客科技的教育者组成</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci2"></svg-icon>
            </div>
            <p>劳逸结合的活动</p>
            <p class="small-tip">营地活动除了STEAM创客科技，还融合自然户外、人文文化等元素</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci3"></svg-icon>
            </div>
            <p>STEAM综合性设计</p>
            <p class="small-tip">活动课程设计沿用前沿的STEAM教学模式，引导营员自我思考和改进等能力</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci4"></svg-icon>
            </div>
            <p>营地安全保障体系</p>
            <p class="small-tip">选择半/全封闭的营地环境，并在营地内配备相应医疗急救员及医疗设施</p>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="footer-content">
      <div class="logo">
        <img src="@/assets/logo_white.png"
             alt="" />
      </div>
      <p class="item-title">少儿编程STEAM创客夏冬令营</p>
      <p class="small-title">适合6~18岁青少年的STEAM创客主题营</p>
      <p class="large-title">
        "我的孩子非常喜欢少儿编程的夏冬令营。他开始变得更外向，
        <br />
        更愿意和别人合作。谢谢你们营地工作人员的设计和照顾。“
      </p>
      <p class="name">伊隆·马斯克</p>
      <p class="small-title">少儿编程STEAM创客夏冬营营员家长</p>
    </div>
    <div class="fix-camp">
      <router-link to="/inside-camp">国内营地</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      type: "preWeek",
      showIndex: '',
      showLogo: false
    };
  },
  created () {
  },
  methods: {
    toDetail (workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`
      });
    },
    toFriend (userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`
      });
    }
  }
};
</script>
<style lang="scss">
.require .ivu-card-shadow {
  box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
  .ivu-card-body {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.camp {
  color: #333;
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: -80px;
  padding-top: 80px;
  background: #fff;
  .top-content {
    height: 706px;
    margin-top: -80px;
    padding-top: 80px;
    background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
    .wdd {
      width: 1500px;
      margin: 0 auto;
      position: relative;
      .top-tip {
        height: 74px;
        background-color: #f59a23;
        height: 74px;
        font-size: 28px;
        color: #fff;
        line-height: 74px;
      }
      .carousel {
        width: 855px;
        margin: 0 auto;
        .demo-carousel {
          height: 398px;
          img {
            width: 580px;
            height: 398px;
          }
        }
        .camp-word {
          color: #ccc;
          padding: 40px 20px;
          text-align: left;
          background: rgba(0, 0, 0, 0.2);
          background: #12212d;
          h1 {
            font-size: 20px;
            margin-bottom: 28px;
          }
          p {
            margin-bottom: 28px;
            font-size: 13px;
            line-height: 2;
          }
          a {
            width: 120px;
            height: 40px;
            margin-top: 10px;
            line-height: 40px;
            text-align: center;
            display: inline-block;
            border-radius: 58px;
            border: 1px solid #ccc;
            &:hover {
              background: rgb(35, 160, 226);
              border-color: rgb(35, 160, 226);
            }
          }
        }
      }
    }
  }
  .explain {
    font-size: 0;
    position: absolute;
    left: -394px;
    top: 608px;
    z-index: 999;
    .wave {
      width: 2440px;

      height: 104px;
    }
  }
  .item-title {
    margin: 40px 0;
    font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
    font-weight: 700;
    font-size: 48px;
  }
  .small-title {
    font-size: 25px;
    max-width: 990px;
    margin: 0 auto;
  }
  .content {
    font-size: 15px;
    width: 1200px;
    margin: 0 auto;
    margin-top: -107px;
    .logo {
      background: #f59a23;
      width: 93px;
      height: 93px;
      border-radius: 50%;
      margin: 0 auto;
      text-align: center;
      position: relative;
      z-index: 1000;
      img {
        width: 55px;
        height: 55px;
        margin-top: 19px;
      }
    }
    .tip {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 60px;
      p {
        font-size: 28px;
        font-weight: 700;
        &.small-tip{
          font-size: 20px;
          font-weight: 400;
          width: 230px;
          margin: 15px auto 0;
        }
      }
      span {
        font-size: 18px;
        display: block;
        width: 86%;
        margin: 0 auto;
        margin-top: 20px;
      }
      .circle {
        background: #fff;
        border-radius: 50%;
        box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
        width: 50%;
        margin: 0 auto;
        padding: 15px 0;
        margin-bottom: 20px;
        height: 140px;
      }
      .circle-svg {
        width: 217px;
        height: 217px;
        svg {
          width: 100%;
          height: 100%;
        }
      }
      img {
        width: 103px;
      }
    }
    .select-btns {
      padding: 20px 100px;
      .btn {
        font-size: 14px;
        padding: 0 28px;
        color: #575757;
        background-color: rgba(228, 228, 228, 1);
        border: none;
        &:hover {
          color: rgb(0, 188, 212);
        }
        &.active {
          background-color: rgba(13, 135, 199, 1);
          color: #fff;
        }
      }
    }
    .course-list {
      width: 1150px;
      margin: 0 auto;
      .item-course {
        margin-bottom: 20px;
        position: relative;
        img{
          width: 355px;
          height: 266px;
        }
        .introduce{
          position: absolute;
          color: #fff;
          top: 49%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 355px;
          height: 266px;
          background: rgba(0, 0, 0, 0.2);
          padding: 40px 20px 0;
          h1 {
            font-size: 44px;
            font-family: sans-serif;
            font-weight: 600;
            font-family: "Rockwell Bold";
          }
          .h{
            text-align: left;
            font-size: 26px;
            font-weight: 700;
            margin-bottom: 135px;
          }
          .btn{
            float: right;
            background: #F59A25;
            border: none;
          }
          span{
            color: #F59A25;
            font-size: 32px;
            font-weight: 700;
          }
          p{
            font-size: 24px;
            font-weight: 600;
          }
        }
      }
    }
    .more-camp{
      text-align: center;
      border: 1px solid #333;
      color: #333;
    }
    .more{
      width: 1200px;
      margin: 50px auto;
      color: #fff;
      font-size: 0;
      img.b{
        width: 520px;
        height: 390px;
        margin-bottom: 80px;
      }
      .more-explain{
        margin-bottom: 80px;
        background: linear-gradient(0deg, rgba(105, 103, 206, 1) -3%, rgba(53, 232, 150, 1) 207%);
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.349019607843137);
        width: 568px;
        height: 522px;
        padding: 20px;
        position: relative;
        text-align: left;
        a{
          text-align: center;
          margin-top: 40px;
          width: 173px;
          height: 61px;
          line-height: 61px;
          background: #f59a23;
          color: #fff;
          font-size: 25px;
          font-weight: 700;
          display: inline-block;
          padding: 0 6px;
          border-radius: 10px;
          margin-right: 20px;
          &:hover{
            background: #444;
          }
        }
        h3{
          font-size: 40px;
        }
        h6{
          font-size: 20px;
          margin: 40px 0;
        }
        p{
          font-size: 20px;
          font-weight: 700;
          line-height: 1.6;
        }
        .logo-i{
          width: 166px;
          position: absolute;
          bottom: 130px;
          right: 115px;
        }
      }
    }
    .ci{
      svg{
        width: 217px;
        height: 217px;
      }
    }
  }

  .footer-content {
    color: #fff;
    background: linear-gradient(
      180deg,
      rgba(53, 232, 150, 1) -117%,
      rgba(105, 103, 206, 1) 96%
    );
    background-size: 100% 140%;
    padding-top: 60px;
    padding-bottom: 100px;
    .large-title {
      margin-top: 40px;
      margin-bottom: 70px;
      font-size: 40px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      line-height: 50px;
    }
    .name {
      margin-bottom: 30px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      font-size: 25px;
    }
    .logo {
      margin: 0 auto;
      width: 93px;
      height: 93px;
      border-radius: 50%;
      background: #f59a23;
      padding-top: 14px;
      img {
        width: 57px;
        height: 60px;
      }
    }
  }

  .fix-camp{
    position: fixed;
    bottom: 100px;
    left: 50px;
    z-index: 9999;
    a{
      color: #fff;
      font-size: 25px;
      width: 68px;
      display: block;
      padding: 10px;
      border-radius: 30px;
      background:rgba(130, 202, 109, 1);
      &:hover{
        background: #444;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/outsideCamp.vue